import Api from "@/repository/api";
import {ResponseDataType} from "@/form/form.types";
import { IauthRepository } from '@/repository/user/auth/authRepository.types'
import { IauthUser, IauthUserResponseType } from '@/entity/user/user.types';
import { authUser } from '@/entity/user/user';
import axios from 'axios'

export class authRepository implements  IauthRepository {
    async login(data?: FormData){
        const response = await Api.post(`/login`,data)
        /*localStorage.setItem('userToken', JSON.stringify(response.data.token));
        console.log('login response -')*/
        console.log('123'+response)
        const respData = response.data as IauthUser


        return new authUser(respData)
    }
}